import React, { useState, useEffect } from 'react';
import styles from './Gallery.module.css';

const images = [
  {
    src: `${process.env.PUBLIC_URL}/images/gallery-1.jpg`,
    alt: 'Annie Class Gallery 1',
  },
  {
    src: `${process.env.PUBLIC_URL}/images/gallery-2.jpg`,
    alt: 'Annie Class Gallery 2',
  },
];

/**
 * Gallery carousel component - displays classroom/teaching photos
 */
function Gallery() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  // Auto-advance slides every 5 seconds
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
  };

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
    setIsAutoPlaying(false);
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
    setIsAutoPlaying(false);
  };

  return (
    <section className={styles.gallery} aria-label="Thư viện ảnh">
      <div className={styles.carouselContainer}>
        <div className={styles.carousel}>
          {images.map((image, index) => (
            <div
              key={index}
              className={`${styles.slide} ${index === currentIndex ? styles.active : ''}`}
              style={{ backgroundImage: `url(${image.src})` }}
              aria-hidden={index !== currentIndex}
            >
              <img src={image.src} alt={image.alt} className={styles.img} />
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <button
          className={`${styles.arrow} ${styles.arrowLeft}`}
          onClick={goToPrevious}
          aria-label="Ảnh trước"
        >
          ‹
        </button>
        <button
          className={`${styles.arrow} ${styles.arrowRight}`}
          onClick={goToNext}
          aria-label="Ảnh tiếp theo"
        >
          ›
        </button>

        {/* Dots Navigation */}
        <div className={styles.dots}>
          {images.map((_, index) => (
            <button
              key={index}
              className={`${styles.dot} ${index === currentIndex ? styles.dotActive : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Đến ảnh ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Gallery;
